import React from 'react'
import './LoginLayout.css'

interface LoginLayoutProps {
  children: React.ReactNode
}

export const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  return (
    <div className="login-layout">
      <div className="login-layout__container">
        {children}
      </div>
    </div>
  )
}
